// @flow
import { connect } from 'react-redux'
import AudiencesSelector from './AudiencesSelector'
import type { Store } from '../../redux/ducks'
import { patch } from '../../redux/ducks/audiencesSelector/reducers'

function mapStateToProps(state: Store) {
  const audiencesSelector = state.audiencesSelector

  return {
    options: audiencesSelector.options,
    value: audiencesSelector.ids,
    errors: audiencesSelector.errors
  }
}

function mapDispatchToProps(dispatch: Function) {
  return {
    onChange: (ids) => dispatch(patch({ ids: ids, errors: [] }))
  }
}

const AudiencesSelectorContainer = connect<Object, Object, _, _, _, _>(
  mapStateToProps,
  mapDispatchToProps
)(AudiencesSelector)

export default AudiencesSelectorContainer
